"use client";
import React, { useState, useEffect } from "react";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import { FellouButton } from "@/ui-components-next/FellouButton";
import { GA_MEASUREMENT_ID } from "@/components/GoogleAnalytics";
import "./styles.scss";

interface AcceptCookieBoxProps {
  className?: string;
}

export default function AcceptCookieBox({ className = "" }: AcceptCookieBoxProps) {
  const [showConsent, setShowConsent] = useState<boolean | undefined>(undefined);
  const [cookieConsent, setCookieConsent] = useState<"all" | "necessary" | null>(null);

  useEffect(() => {
    // 检查本地存储中是否已有选择
    const savedConsent = localStorage.getItem("fellou-cookie-consent");
    if (savedConsent) {
      setCookieConsent(savedConsent as "all" | "necessary");
      setShowConsent(false);
    } else {
      // 只有在确认没有保存的选择时才显示提示框
      setShowConsent(true);
    }
  }, []);

  const handleCookieConsent = (type: "all" | "necessary") => {
    localStorage.setItem("fellou-cookie-consent", type);
    setCookieConsent(type);
    setShowConsent(false);

    if (type === "necessary") {
      // 禁用 GA
      window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
    }
  };

  return (
    <>
      {showConsent === true && (
        <div className={`consent-cookie-box ${className}`}>
          <div className="consent-cookie-content">
            We use cookies to help improve our website and product. You can choose to accept only the necessary cookies
            or allow all cookies for enhanced functionality. You can update your preferences at any time.
          </div>

          <div className="consent-cookie-buttons">
            <FellouButton
              className="consult-btn cursor-pointer"
              mode="dominant-color-big"
              onClick={() => handleCookieConsent("all")}
            >
              Accept All Cookies
            </FellouButton>
            <FellouButton
              className="consult-btn cursor-pointer"
              mode="dominant-color-big"
              onClick={() => handleCookieConsent("necessary")}
            >
              Necessary Cookies Only
            </FellouButton>
          </div>
        </div>
      )}
      {cookieConsent !== "necessary" && <GoogleAnalytics />}
    </>
  );
}
